export enum EdsFilterEntities {
  Id = 'Id',
  PolicyId = 'PolicyId',
  ClaimId = 'ClaimId',
  ClaimSetId = 'ClaimSetId',
  AssigneeId = 'AssigneeId',
  ParentEntityType = 'ParentEntityType',
  ParentEntityKey = 'ParentEntityKey',
  EntityType = 'EntityType',
  BeneficiaryId = 'BeneficiaryId',
  InsuredId = 'InsuredId',
  PersonId = 'PersonId',
  BusinessId = 'BusinessId',
  PaymentId = 'PaymentId',
  BenefitId = 'BenefitId',
  TransactionStatus = 'TransactionStatus',
  RelatedEntityType = 'RelatedEntityType',
  RelatedEntityKey = 'RelatedEntityKey',
  HelperTag = 'HelperTag',
  DocumentTypeId = 'DocumentTypeId',
  ProducerId = 'ProducerId',
  ProducerGroupId = 'ProducerGroupId',
}
